import { Card, CardContent, CardHeader, CardTitle } from './ui/card'
import { Button } from './ui/button'
import { Wrench, Shield, Clock, Award,Hammer,Paintbrush,Drill } from 'lucide-react'
import { ImageWithFallback } from './figma/ImageWithFallback'

export function ServicesSection() {
  const services = [
    {
      icon: Drill,
      title: "Шиномонтаж легковых автомобилей",
      description: "Профессиональная установка шин на диски с использованием современного оборудования",
      price: "от 1200 ₽"
    }, 
    {
      icon: Shield,
      title: "Балансировка колёс",
      description: "Точная балансировка для обеспечения комфортной и безопасной езды",
      price: "от 800₽"
    },
    {
      icon: Paintbrush,
      title: "Порошковая и акриловая покраска колёсных дисков",
      description: "Мы предлагаем профессиональную покраску дисков порошковым и акриловым методом, чтобы вернуть им первозданный вид или создать совершенно новый, уникальный дизайн.",
      price: "от 2000 ₽"
    },
    {
      icon: Clock,
      title: "Сезонное хранение колёс",
      description: "Безопасное и надёжное хранение ваших колёс в оптимальных условиях",
      price: "от 400 ₽"
    },
    {
      icon: Wrench,
      title: "Ремонт дисков",
      description: "Восстановление геометрии дисков, устраняя вмятины и искривления, возникшие в результате ударов и неровностей дорог. Это позволяет вернуть дискам их первоначальную форму, обеспечивая плавность хода и предотвращая неравномерный износ шин.",
      price: "от 500 ₽"
    },
    {
      icon: Hammer,
      title: "Дошиповка шин",
      description: "Мы знаем, какие шипы лучше всего подходят для ваших шин и как правильно их установить, чтобы обеспечить максимальную эффективность и долговечность.",
      price: "от 25 ₽"
    }
  ]

  return (
    <section id="services" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
           Ваш надежный партнер в мире авто
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            У нас вы найдете большой выбор шин, дисков и запчастей для легковых автомобилей; шин для мотоциклов и Спецтехники. Мы предлагаем профессиональную установку шин и сезонное хранение, все это с заботой и профессионализмом.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mb-12">
          <div>
            <ImageWithFallback
              src="https://img.intershina.pro/images/service.jpeg"
              alt="Интершина"
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {services.map((service, index) => {
              const IconComponent = service.icon
              return (
                <Card key={index} className="hover:shadow-md transition-shadow">
                  <CardHeader className="pb-3">
                    <div className="flex items-center space-x-3">
                      <div className="p-2 bg-[#ed8510]/10 rounded-lg">
                        <IconComponent className="h-5 w-5 text-[#ed8510]" />
                      </div>
                      <CardTitle className="text-base">{service.title}</CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <p className="text-sm text-gray-600 mb-2">{service.description}</p>
                    <p className="text-sm font-semibold text-[#ed8510]">{service.price}</p>
                  </CardContent>
                </Card>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}